import Icon from '../components/Icon.vue'

Icon.register({
  'hand-middle-finger': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M479.9 317.1l0.1 82.9v0c0 61.8-50.2 112-112 112h-215c-25.6 0-61.1-14.7-79.2-32.8l-30.9-30.9c-6-6-10.9-17.9-10.9-26.4v0-73.5 0c0-12.7 9.2-27.7 20.6-33.4l27.4-15v76c0 4.4 3.6 8 8 8s8-3.6 8-8v-147c0-15.3 12.9-28.4 30.9-31.4l30.7-5.1c17.8-3 34.5 8.4 34.5 23.5v32c0 4.4 3.6 8 8 8s8-3.6 8-8v-200 0c0-26.5 21.5-48 48-48 0.4 0 1.1 0 1.5 0 26.3 0.8 46.5 23.7 46.5 50v198c0 4.4 3.6 8 8 8s8-3.6 8-8v-32c0-15.1 16.6-26.5 34.5-23.5l38.4 6.4c13.5 2.3 23.2 12.1 23.2 23.5v49.6l35.7 8.9c15.6 3.9 28.3 20.1 28.3 36.2z'
      }
    ]
  }
})
